import React, { useState, useMemo } from "react";
import { Card, Button, Col, Row, Form } from "react-bootstrap";

export default function InscripcionCursosCard({
  datos,
  accion,
  btnIcon,
  btnVariant,
  btnTitle,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredAndSortedDatos = useMemo(() => {
    if (!datos || datos.length === 0) {
      return [];
    }

    let filtered = datos.filter((curso) => {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      return (
        curso.descripcionCurso.toLowerCase().includes(lowerCaseSearchTerm) ||
        (curso.docentesCurso &&
          curso.docentesCurso.toLowerCase().includes(lowerCaseSearchTerm))
      );
    });

    return filtered.sort((a, b) =>
      a.descripcionCurso.localeCompare(b.descripcionCurso, "es", {
        sensitivity: "accent",
      })
    );
  }, [datos, searchTerm]);

  if (!datos || datos.length === 0) {
    return <p className="text-center">No hay cursos para mostrar.</p>;
  }

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="Buscar por curso o profesor..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form.Group>
      <div className="card-container-scrollable">
        {filteredAndSortedDatos.length === 0 ? (
          <p className="text-center">
            No se encontraron cursos con los criterios de búsqueda.
          </p>
        ) : (
          <Row xs={1} md={2} lg={3} className="g-4">
            {filteredAndSortedDatos.map((curso) => (
              <Col key={curso.id}>
                <Card className="h-100 shadow card-fixed-height">
                  <Card.Header as="h5">{curso.descripcionCurso}</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <strong>Horarios:</strong> {curso.horarios}
                    </Card.Text>
                    <Card.Text>
                      <strong>Año:</strong> {curso.anioCarrera}
                    </Card.Text>
                    <Card.Text>
                      <strong>Profesor(es):</strong> {curso.docentesCurso}
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <Button
                      onClick={() => accion({ cursoSelected: { data: curso } })}
                      variant={btnVariant}
                      title={btnTitle}
                      disabled={curso.disabled || !curso.inscripcionHabilitada}
                      className="w-100"
                    >
                      {btnIcon} {btnTitle}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </>
  );
}
